import React from 'react';
import PurpleGlyph from '../../../images/logos/nurelm-glyph-purple.svg';

const NuRelmSpinner = () => <img src={PurpleGlyph} alt="Loading..." />;

export default NuRelmSpinner;
